import { useQuery } from '@tanstack/react-query'
import { Link } from 'react-router-dom'
import { adminApi } from '../../lib/api'
import { PageLoading } from '../../components/LoadingSpinner'

export function SuperadminDashboard() {
  const { data: metrics, isLoading } = useQuery({
    queryKey: ['admin', 'metrics'],
    queryFn: adminApi.metrics,
  })

  if (isLoading) return <PageLoading />

  return (
    <div>
      <h1 style={{ fontSize: 'var(--font-size-2xl)', fontWeight: 700, marginBottom: 'var(--space-2)' }}>
        Super Admin
      </h1>
      <p style={{ color: 'var(--color-gray-600)', marginBottom: 'var(--space-8)', fontSize: 'var(--font-size-sm)' }}>
        Todas as ações neste painel são registradas na trilha de auditoria.
      </p>

      <div
        style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))',
          gap: 'var(--space-4)',
          marginBottom: 'var(--space-8)',
        }}
      >
        <MetricCard
          label="Total de tenants"
          value={metrics?.total_tenants ?? '—'}
          color="var(--color-primary)"
        />
        <MetricCard
          label="Assinaturas ativas"
          value={metrics?.assinaturas_ativas ?? '—'}
          color="var(--color-success)"
        />
      </div>

      {/* Por plano */}
      {metrics?.tenants_por_plano && metrics.tenants_por_plano.length > 0 && (
        <div className="card" style={{ marginBottom: 'var(--space-6)' }}>
          <h2 style={{ fontSize: 'var(--font-size-lg)', fontWeight: 600, marginBottom: 'var(--space-4)' }}>
            Distribuição por plano
          </h2>
          <div style={{ display: 'flex', gap: 'var(--space-6)', flexWrap: 'wrap' }}>
            {metrics.tenants_por_plano.map((p) => (
              <div key={p.plan}>
                <div style={{ fontSize: 'var(--font-size-2xl)', fontWeight: 700 }}>{p.count}</div>
                <div style={{ fontSize: 'var(--font-size-sm)', color: 'var(--color-gray-600)' }}>{p.plan}</div>
              </div>
            ))}
          </div>
        </div>
      )}

      <div className="card">
        <h2 style={{ fontSize: 'var(--font-size-lg)', fontWeight: 600, marginBottom: 'var(--space-4)' }}>
          Ações
        </h2>
        <div style={{ display: 'flex', gap: 'var(--space-3)' }}>
          <Link to="/superadmin/tenants" className="btn btn-primary">Gerenciar tenants</Link>
        </div>
      </div>
    </div>
  )
}

function MetricCard({ label, value, color }: { label: string; value: number | string; color: string }) {
  return (
    <div className="card" style={{ borderLeft: `4px solid ${color}` }}>
      <div style={{ fontSize: 'var(--font-size-sm)', color: 'var(--color-gray-600)', marginBottom: 'var(--space-1)' }}>
        {label}
      </div>
      <div style={{ fontSize: 'var(--font-size-3xl)', fontWeight: 700, color }}>{value}</div>
    </div>
  )
}
